export default __webpack_public_path__ + "static/media/top-title-zh.18ecb2a4.png";